/*eslint no-process-env: 0*/

// Runtime config lookup, same pattern as oclmap: in production the value is
// injected as a window global by start-prod.sh (env-config.js); in
// development it comes from webpack DefinePlugin.
export const getAPIURL = () => {
  const url = (typeof window !== 'undefined' && window.API_URL) || process.env.API_URL || 'http://127.0.0.1:8000';
  return url.replace(/\/$/, '');
};

export const getLoginRedirectURL = () => (typeof window !== 'undefined' && window.LOGIN_REDIRECT_URL) || process.env.LOGIN_REDIRECT_URL;

// "3 days ago"-style relative timestamps (no moment dependency).
export const timeAgo = (dateString, now = Date.now()) => {
  const seconds = Math.max(0, Math.floor((now - new Date(dateString).getTime()) / 1000));
  const units = [
    [31536000, 'year'], [2592000, 'month'], [86400, 'day'],
    [3600, 'hour'], [60, 'minute'],
  ];
  for (const [size, label] of units) {
    const count = Math.floor(seconds / size);
    if (count >= 1)
      return `${count} ${label}${count > 1 ? 's' : ''} ago`;
  }
  return 'just now';
};


const configuredURL = value => (value || '').trim().replace(/\/+$/, '');

export const resolveV3URL = (configured, host, origin) => {
  const url = configuredURL(configured);
  if(url)
    return url;
  if(host?.includes('localhost'))
    return 'http://localhost:4002';
  if(['map.dev.openconceptlab.org', 'map.demo.openconceptlab.org'].includes(host))
    return 'https://app.v3.qa.openconceptlab.org';
  if(host?.match('map.*.openconceptlab.org'))
    return origin.replace('//map.', '//app.v3.');
  return 'https://app.v3.openconceptlab.org';
};

export const resolveMapperURL = (configured, host, origin) => {
  const url = configuredURL(configured);
  if(url)
    return url;
  if(host?.includes('localhost'))
    return 'http://localhost:4004';
  if(['app.v3.qa.openconceptlab.org', 'app.v3.demo.openconceptlab.org'].includes(host))
    return 'https://map.qa.openconceptlab.org';
  if(host?.match('app.v3.*.openconceptlab.org'))
    return origin.replace('//app.v3.', '//map.');
  return 'https://map.openconceptlab.org';
};

const isRecognizedHost = host => Boolean(host) && (host.includes('localhost') || host === 'openconceptlab.org' || host.endsWith('.openconceptlab.org'));

export const resolveIntegratedV3URL = (configured, host, origin) =>
  configuredURL(configured) || isRecognizedHost(host) ? resolveV3URL(configured, host, origin) : '';

export const resolveIntegratedMapperURL = (configured, host, origin) =>
  configuredURL(configured) || isRecognizedHost(host) ? resolveMapperURL(configured, host, origin) : '';

export const getV3URL = () => resolveV3URL(window.TERMBROWSER_URL || process.env.TERMBROWSER_URL, window.location.host, window.location.origin);

export const getMapperURL = () => resolveMapperURL(window.MAPPER_URL || process.env.MAPPER_URL, window.location.host, window.location.origin);

export const toV3URL = path => `${getV3URL()}${path || '/'}?referrer=${window.location.href}`;

export const toMapperURL = path => `${getMapperURL()}${path || '/'}?referrer=${window.location.href}`;

export const hasTermBrowser = () => Boolean(resolveIntegratedV3URL(window.TERMBROWSER_URL || process.env.TERMBROWSER_URL, window.location.host, window.location.origin));

export const hasMapper = () => Boolean(resolveIntegratedMapperURL(window.MAPPER_URL || process.env.MAPPER_URL, window.location.host, window.location.origin));
